export default __webpack_public_path__ + "/dist/images/invitations-inactive.0355f21279d2ed53ce54572b868d9d7a.svg";